import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ConfirmModalModule, ErrorContainerModule, ErrorShowingModule } from 'ccc-commons/core';
import { UserModalComponent } from './user-modal/user-modal.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    ConfirmModalModule,
    ErrorContainerModule,
    ErrorShowingModule
  ],
  declarations: [UserModalComponent],
  exports: [UserModalComponent]
})
export class UserModalModule { }
